export const cookieMaxAge = 3600000 * 24 * 365 * 3 // 3 years
export const cookieOptions = { path: '/', maxAge: cookieMaxAge }

export const baseCurrencyCookieName = 'base-currency'
